import dayjs from 'dayjs';
import { Country } from '../models/serializable/country.js';
import { Language } from '../models/serializable/language.js';
import { MembershipRole } from '../models/serializable/membership-role.js';
import { DataModel } from '../models/dto/dto.js';
import { BusinessModuleType } from '../models/serializable/business-module-type.js';
import { TimeZoneRegion } from '../models/serializable/time-zone-region.js';
import { DashboardType } from '../models/serializable/dashboard-type.js';

export abstract class BusinessMembershipBase extends DataModel {
  abstract get uniqueId(): string;
  abstract get businessId(): string;
  abstract get creatorId(): string;
  abstract get organizationId(): string;
  abstract get name(): string;
  abstract get partnerRole(): MembershipRole;
  abstract get creationDate(): dayjs.Dayjs;
  abstract get country(): Country;
  abstract get language(): Language;
  abstract get timezone(): TimeZoneRegion;
  abstract get moduleType(): BusinessModuleType;

  abstract hasDashboard(dashboard: DashboardType): boolean;
  abstract addDashboard(dashboard: DashboardType): void;
  abstract getDashboards(): DashboardType[];
}
